import "../enums/accordion.js";
import "../enums/alert.js";
import "../enums/avatar.js";
import "../enums/breakpoints.js";
import "../enums/button.js";
import "../enums/code-editor.js";
import { BrandfolderHexColors } from "../enums/colors.js";
import "../enums/combobox.js";
import "../enums/date.js";
import "../enums/drag-and-drop.js";
import "../enums/dialog.js";
import "../enums/divider.js";
import "../enums/dropdown.js";
import "../enums/fieldset.js";
import "../enums/font-icon.js";
import "../enums/fonts.js";
import "../enums/headings.js";
import "../enums/input.js";
import "../enums/keys.js";
import "../enums/list.js";
import "../enums/listbox.js";
import "../enums/loader.js";
import "../enums/margin.js";
import "../enums/option.js";
import "../enums/pill.js";
import "../enums/placements.js";
import "../enums/popout.js";
import "../enums/privacy.js";
import "../enums/radio-group.js";
import "../enums/status.js";
import "../enums/switch.js";
import "../enums/table.js";
import "../enums/tooltip.js";
import "../enums/transitions.js";
import "../enums/widths.js";
var defaultOptionDark = {
  backgroundColor: '#333',
  backgroundColorHover: BrandfolderHexColors.Text,
  backgroundColorSelected: BrandfolderHexColors.GrayDark,
  textColor: BrandfolderHexColors.White,
  textColorDisabled: '#BCBCBC'
};
var defaultOptionLight = {
  backgroundColor: BrandfolderHexColors.White,
  backgroundColorHover: BrandfolderHexColors.DirtyMarshmallowHalf,
  backgroundColorSelected: BrandfolderHexColors.DirtyMarshmallow,
  textColor: BrandfolderHexColors.Text,
  textColorDisabled: BrandfolderHexColors.GrayMedium
};
export { defaultOptionDark, defaultOptionLight };